import { render, staticRenderFns } from "./RefundInfoModal.vue?vue&type=template&id=0c8f20a4&scoped=true"
import script from "./RefundInfoModal.vue?vue&type=script&lang=js"
export * from "./RefundInfoModal.vue?vue&type=script&lang=js"
import style0 from "./RefundInfoModal.vue?vue&type=style&index=0&id=0c8f20a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8f20a4",
  null
  
)

export default component.exports